import { useEffect } from 'react'

import { useIsDarkMode } from '@/state/user/hooks'

/** Sincroniza la clase `.dark` de Tailwind/shadcn con el toggle de Redux. */
export function DarkModeDocumentSync() {
  const darkMode = useIsDarkMode()

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode)
    document.documentElement.style.colorScheme = darkMode ? 'dark' : 'light'
  }, [darkMode])

  return null
}
